import { Box } from '@mui/material';
import BaseDialog from '../ui/BaseDialog';
import { useTranslation } from 'react-i18next';
import { useLayoutState } from '@/provider/layouts/layoutContext';
import { useCallback } from 'react';

const PreviewLayoutErrorDialog = () => {
    const { t } = useTranslation('common');
    const { state, dispatch } = useLayoutState();
    const handleOnPreviewErrorClose = useCallback(
        () => dispatch({ type: 'TOGGLE_DIALOG', payload: { key: 'previewError', open: false } }),
        [],
    );
    return (
        <BaseDialog
            open={state.dialogs.previewError}
            dialogTitle={t('Preview Generation Errors')}
            onClose={handleOnPreviewErrorClose}
            TransitionProps={{
                onExited: () => {
                    dispatch({ type: 'SET_PREVIEW_ERROR', payload: [] });
                },
            }}
        >
            <Box component="ul" sx={{ pl: 2, m: 0 }}>
                {state.previewError.map(({ key, message }) => (
                    <li key={key}>
                        <strong>{key}</strong> — {message}
                    </li>
                ))}
            </Box>
        </BaseDialog>
    );
};
export default PreviewLayoutErrorDialog;
